module.exports = __webpack_public_path__ + "static/img/xuanzhongyinpin.png@2x.9391bba8.png";